import { render, staticRenderFns } from "./TextContents.vue?vue&type=template&id=25d42b56&"
import script from "./TextContents.vue?vue&type=script&lang=js&"
export * from "./TextContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports